/* MISSY JavaScript: myMetadata, browseViaTopic and export */

var numberAddedToWatchlist = 0;
var metaBoxWatchList = [];

$(window).on("load", function() {
  
  // Exporting Variable availability over time to csv
  if( $( '.exportMatrixToCSV').length ){
    $( '.exportMatrixToCSV' ).click( function (){
      exportMetaMatrix( $(this) , ";");
    });
    
    var href = document.location.href;
    if ( ~href.indexOf('?export') ) {
      $( '.exportMatrixToCSV' ).get(0).click();      
    }
  }

  // Exporting selected Variable availability over time to csv
  if( $( '.exportSelectedMatrixToCSV').length ){
    $( '.exportSelectedMatrixToCSV' ).click( function (){
      exportSelectedMetaMatrix( $(this) , ";");
    });
  }
  
  // Exporting Variable availability over time to csv without id`s
  if( $( '.exportWithoutIdsMatrixToCSV').length ){
    $( '.exportWithoutIdsMatrixToCSV' ).click( function (){
      exportWithoutIdMetaMatrix( $(this) , ";");
    });
  }

  // Exporting selected Variable availability over time to csv without id`s
  if( $( '.exportSelectedWithoutIdsMatrixToCSV').length ){
    $( '.exportSelectedWithoutIdsMatrixToCSV' ).click( function (){
      exportSelectedWithoutIdMetaMatrix( $(this) , ";");
    });
  }

  // Exporting Dataset availability over time & countries to csv
  if( $( '.exportDatasetToCsv').length ){
    $( '.exportDatasetToCsv' ).click( function (){
      exportDatasetCountries( $(this) , ";");
    });
  }
  
  // Exporting Compare Variables to csv
  if( $( '.exportVariableToCsv').length ){
    $( '.exportVariableToCsv' ).click( function (){
      exportCompareVariables( $(this) , ";");
    });
  }
});

/* meta matrix export - Exporting Variable availability over time (complete with ID's) */
function exportMetaMatrix( $triggerElem , separator){
  var studyGroup = $('#m_submenu .m_submenu_seriesBlock.m_active a').text();
  
  separator = typeof separator !== 'undefined' ? separator : ",";
  // select active table element
  var $containerElem = $( 'div.tabContent' );
  var $tableElem = null;
  if( $containerElem.length >= 1) {
    $tableElem = $( 'div.tabContent > div > table');
  }

  if( typeof $tableElem === "undefined" ){
    alert( "table missing" );
    return false;
  }
  
  // the variables
  var tableTitle = [];
  var tableArrayContent = [];
  
  tableTitle.push("MISSY");
  
  // get the title and change sequence so studyGroup will be added first
  var h1String = $('.gs-content > h1').text();
  h1Parts = h1String.split(": ");
  tableTitle.push(h1Parts[1]);
  tableTitle.push(h1Parts[0]);
  // tableTitle.push( $( document ).find( "h1:first" ).text());
  
  // get the sub title if exist
  if( $( 'ul.tabs' ).length )
    tableTitle.push( $( 'ul.tabs' ).find( 'a.active' ).text() );
    
  // include the tree structure.
  // - use stack to help extracting tree structure
  // - use 2 2-dimension array
  //   - first for conceptStructure (the tree structure)
  //   - second for the concept content
  // - this 2 array, later will be merged
  // extracting structure will use id of elements
  // = variables =
  var treeDepestLevel = 0;
  var treeCurrentLevel = 0;
  var treeStructureStack = [];
  var conceptStructure = [];
  var conceptContent =[];
  
  // console.log($tableElem);

  // tablecontent, get all of tr
  $tableElem.find( 'tr').each( function(){
    // first check element visibility, skip if invisible
    /* allways complete table
    if( !$( this ).is( ":visible" ) )
      return true;*/
      
    var conceptStructureRow = [];
    var conceptContentRow = [];
    
    // get tr detail, regarding its concept and id
    // var trConcept = $( this ).attr( "concept" );
    var trConcept = $( this ).attr( "topic" );
    var trId = $( this ).attr( "id" );
    var themconceptid = $( this ).attr( "themconceptid" );
    var broaderid = $( this ).attr( "broaderid" );
    TextDecoderStream;
    
    if ( typeof trConcept === "undefined" ) {
      treeCurrentLevel = 1;
    } else {
      treeCurrentLevel = 0;
    }
    
    // loop through tr children either td or th
    $( this ).children().each( function( index ){
      var columnData = "";
      if( $( this ).find( "span.studyHeader").length === 0 )
        columnData = $.trim( $( this ).text());
      // removing white space that can not be done with trim
      columnData = columnData.replace(/\s+/g, ' ');
      // check if there is a comma in the column text
      if( columnData.indexOf( separator ) !== -1)
        columnData = '"' + columnData + '"';
      
      if( index == 0 ){ // processing first column (the tree)
        for(var i=0 ; i <= treeCurrentLevel ; i++ ){
          if( i == treeCurrentLevel)
          {
            if (themconceptid !== undefined) conceptStructureRow.push( themconceptid );
            if (broaderid !== undefined) conceptStructureRow.push( broaderid );
            if (themconceptid !== undefined && broaderid == undefined)
            {
              conceptStructureRow.push( "" );
            }
            else if( columnData == "") 
            {
              conceptStructureRow.push( "" );
              conceptStructureRow.push( "" );
            }

            conceptStructureRow.push( columnData );
          }
        }
        
      } else { // processing the rest columns
        if ( $(this).attr("class") !== "showIfEmpty" ) {
          conceptContentRow.push( columnData );
          // if contain colspan
          var columnColspan = $( this ).attr( 'colspan' );
          if( typeof columnColspan !== "undefined" && columnColspan !== false )
          for(var i=1 ; i < columnColspan ; i++)
            conceptContentRow.push( conceptContentRow[ conceptContentRow.length - 1 ]);
        }
      }
    });
    conceptStructure.push( conceptStructureRow );
    conceptContent.push( conceptContentRow );
  });
  
  // merge the two array
  for( var i = 0 ; i < conceptStructure.length ; i++ ){
    // get the length of first array
    var structureLength = conceptStructure[i].length;
    // before merging, equate the length of structure array
    for( var j = structureLength; j <= treeDepestLevel ; j++ ){
      conceptStructure[i].push( "" ); // push empty value
    }
    tableArrayContent.push( conceptStructure[i].concat( conceptContent[i] ) );
  }
  // print csv
  printTable( $triggerElem, tableTitle, tableArrayContent, separator, "csv" );
}

/* meta matrix export - Exporting Variable availability over time (complete without ID's) */
function exportWithoutIdMetaMatrix( $triggerElem , separator){
  var studyGroup = $('#m_submenu .m_submenu_seriesBlock.m_active a').text();
  
  separator = typeof separator !== 'undefined' ? separator : ",";
  // select active table element
  var $containerElem = $( 'div.tabContent' );
  var $tableElem = null;
  if( $containerElem.length >= 1) {
    $tableElem = $( 'div.tabContent > div > table');
  }

  if( typeof $tableElem === "undefined" ){
    alert( "table missing" );
    return false;
  }
  
  // the variables
  var tableTitle = [];
  var tableArrayContent = [];
  
  tableTitle.push("MISSY");
  
  // get the title and change sequence so studyGroup will be added first
  var h1String = $('.gs-content > h1').text();
  h1Parts = h1String.split(": ");
  tableTitle.push(h1Parts[1]);
  tableTitle.push(h1Parts[0]);
  // tableTitle.push( $( document ).find( "h1:first" ).text());
  
  // get the sub title if exist
  if( $( 'ul.tabs' ).length )
    tableTitle.push( $( 'ul.tabs' ).find( 'a.active' ).text() );
    
  // include the tree structure.
  // - use stack to help extracting tree structure
  // - use 2 2-dimension array
  //   - first for conceptStructure (the tree structure)
  //   - second for the concept content
  // - this 2 array, later will be merged
  // extracting structure will use id of elements
  // = variables =
  var treeDepestLevel = 0;
  var treeCurrentLevel = 0;
  var treeStructureStack = [];
  var conceptStructure = [];
  var conceptContent =[];
  
  // console.log($tableElem);

  // tablecontent, get all of tr
  $tableElem.find( 'tr').each( function(){
    var conceptStructureRow = [];
    var conceptContentRow = [];
    
    // get tr detail, regarding its concept and id
    // var trConcept = $( this ).attr( "concept" );
    var trConcept = $( this ).attr( "topic" );
    var trId = $( this ).attr( "id" );
    TextDecoderStream;
        
    if ( typeof trConcept === "undefined" ) {
      treeCurrentLevel = 1;
    } else {
      treeCurrentLevel = 0;
    }
    
    // loop through tr children either td or th
    $( this ).children().each( function( index ){
      var columnData = "";
      if( $( this ).find( "span.studyHeader").length === 0 )
        columnData = $.trim( $( this ).text());
      // removing white space that can not be done with trim
      columnData = columnData.replace(/\s+/g, ' ');
      // check if there is a comma in the column text
      if( columnData.indexOf( separator ) !== -1)
        columnData = '"' + columnData + '"';
        
      if( index == 0 ){ // processing first column (the tree)
        for(var i=0 ; i <= treeCurrentLevel ; i++ ){
          if( i == treeCurrentLevel)
            conceptStructureRow.push( columnData );
          else
            conceptStructureRow.push( "" );
        }
        
      } else { // processing the rest columns
    if ( $(this).attr("class") !== "showIfEmpty" ) {
      conceptContentRow.push( columnData );
      // if contain colspan
      var columnColspan = $( this ).attr( 'colspan' );
      if( typeof columnColspan !== "undefined" && columnColspan !== false )
      for(var i=1 ; i < columnColspan ; i++)
        conceptContentRow.push( conceptContentRow[ conceptContentRow.length - 1 ]);
    }
      }
    });
    conceptStructure.push( conceptStructureRow );
    conceptContent.push( conceptContentRow );
  });
  
  // merge the two array
  for( var i = 0 ; i < conceptStructure.length ; i++ ){
    // get the length of first array
    var structureLength = conceptStructure[i].length;
    // before merging, equate the length of structure array
    for( var j = structureLength; j <= treeDepestLevel ; j++ ){
      conceptStructure[i].push( "" ); // push empty value
    }
    tableArrayContent.push(  conceptStructure[i].concat( conceptContent[i] ) );
  }
  // print csv
  printTable( $triggerElem, tableTitle, tableArrayContent, separator, "csv" );
  
}

/* meta matrix export - Exporting selected Variable availability over time (selcted with ID's) */
function exportSelectedMetaMatrix( $triggerElem , separator){
  var studyGroup = $('#m_submenu .m_submenu_seriesBlock.m_active a').text();
  
  separator = typeof separator !== 'undefined' ? separator : ",";
  // select active table element
  var $containerElem = $( 'div.tabContent' );
 
  if( $containerElem.length >= 1) {
    $tableElem = $( 'div:not([style*="display: none;"]).tabContent > div > table');
  }

  if( typeof $tableElem === "undefined" ){
    alert( "table missing" );
    return false;
  }
  
  // the variables
  var tableTitle = [];
  var tableArrayContent = [];
  
  tableTitle.push("MISSY");
  
  // get the title and change sequence so studyGroup will be added first
  var h1String = $('.gs-content > h1').text();
  h1Parts = h1String.split(": ");
  tableTitle.push(h1Parts[1]);
  tableTitle.push(h1Parts[0]);
  // tableTitle.push( $( document ).find( "h1:first" ).text());
  
  // get the sub title if exist
  if( $( 'ul.tabs' ).length )
    tableTitle.push( $( 'ul.tabs' ).find( 'a.active' ).text() );
    
  // include the tree structure.
  // - use stack to help extracting tree structure
  // - use 2 2-dimension array
  //   - first for conceptStructure (the tree structure)
  //   - second for the concept content
  // - this 2 array, later will be merged
  // extracting structure will use id of elements
  // = variables =
  var treeDepestLevel = 0;
  var treeCurrentLevel = 0;
  var treeStructureStack = [];
  var conceptStructure = [];
  var conceptContent =[];
  
  // console.log($tableElem);

  // tablecontent, get all of tr
  $tableElem.find( 'tr').each( function(){
    var conceptStructureRow = [];
    var conceptContentRow = [];
    
    // get tr detail, regarding its concept and id
    // var trConcept = $( this ).attr( "concept" );
    var trConcept = $( this ).attr( "topic" );
    var trId = $( this ).attr( "id" );
    var themconceptid = $( this ).attr( "themconceptid" );

    var elementClassRow = $( this ).attr( "class" );
    var isHideRow = undefined;
    if (elementClassRow !== "undefined"){
      isHideRow = false;
      if (elementClassRow.includes("hide")){
        isHideRow = true;
      }
    }
    var broaderid = $( this ).attr( "broaderid" );
    TextDecoderStream;

    if ( typeof trConcept === "undefined" ) {
      treeCurrentLevel = 1;
    } else {
      treeCurrentLevel = 0;
    }
    
    // loop through tr children either td or th
    $( this ).children().each( function( index ){
      var columnData = "";
      var elementClassCol = $( this ).attr( "class" );
      var isHideCol = undefined;

      if (isHideRow == true){
        isHideCol = true;
      }
      else{
        if (elementClassCol !== "undefined"){
          isHideCol = false;
          if (elementClassCol.includes("hide")){
            isHideCol = true;
          }
        }
      }

      if( $( this ).find( "span.studyHeader").length === 0 )
        columnData = $.trim( $( this ).text());
      // removing white space that can not be done with trim
      columnData = columnData.replace(/\s+/g, ' ');
      // check if there is a comma in the column text
      if( columnData.indexOf( separator ) !== -1)
        columnData = '"' + columnData + '"';
      
      if (isHideCol !== true){
        if( index == 0 ){ // processing first column (the tree)
          for(var i=0 ; i <= treeCurrentLevel ; i++ ){
            if( i == treeCurrentLevel)
            {
              if (themconceptid !== undefined) conceptStructureRow.push( themconceptid );
              if (broaderid !== undefined) conceptStructureRow.push( broaderid );
              if (themconceptid !== undefined && broaderid == undefined)
              {
                conceptStructureRow.push( "" );
              }
              else if( columnData == "") 
              {
                conceptStructureRow.push( "" );
                conceptStructureRow.push( "" );
              }
              conceptStructureRow.push( columnData );
            }
          }
          
        } else { // processing the rest columns
          if ( $(this).attr("class") !== "showIfEmpty" ) {
            conceptContentRow.push( columnData );
            // if contain colspan
            var columnColspan = $( this ).attr( 'colspan' );
            if( typeof columnColspan !== "undefined" && columnColspan !== false )
            for(var i=1 ; i < columnColspan ; i++)
              conceptContentRow.push( conceptContentRow[ conceptContentRow.length - 1 ]);
          }
        }
      }
    });

    if (isHideRow !== true){
      conceptStructure.push( conceptStructureRow );
      conceptContent.push( conceptContentRow );
    }
  });
  
  // merge the two array
  for( var i = 0 ; i < conceptStructure.length ; i++ ){
    // get the length of first array
    var structureLength = conceptStructure[i].length;
    // before merging, equate the length of structure array
    for( var j = structureLength; j <= treeDepestLevel ; j++ ){
      conceptStructure[i].push( "" ); // push empty value
    }
    tableArrayContent.push(  conceptStructure[i].concat( conceptContent[i] ) );
  }
  // print csv
  printTable( $triggerElem, tableTitle, tableArrayContent, separator, "csv" );
}

/* meta matrix export - Exporting selected Variable availability over time (selected without ID's) */
function exportSelectedWithoutIdMetaMatrix( $triggerElem , separator){
  var studyGroup = $('#m_submenu .m_submenu_seriesBlock.m_active a').text();
  
  separator = typeof separator !== 'undefined' ? separator : ",";
  // select active table element
  var $containerElem = $( 'div.tabContent' );
  var $tableElem = null;
  if( $containerElem.length >= 1) {
    $tableElem = $( 'div:not([style*="display: none;"]).tabContent > div > table');
  }

  if( typeof $tableElem === "undefined" ){
    alert( "table missing" );
    return false;
  }
  
  // the variables
  var tableTitle = [];
  var tableArrayContent = [];
  
  tableTitle.push("MISSY");
  
  // get the title and change sequence so studyGroup will be added first
  var h1String = $('.gs-content > h1').text();
  h1Parts = h1String.split(": ");
  tableTitle.push(h1Parts[1]);
  tableTitle.push(h1Parts[0]);
  // tableTitle.push( $( document ).find( "h1:first" ).text());
  
  // get the sub title if exist
  if( $( 'ul.tabs' ).length )
    tableTitle.push( $( 'ul.tabs' ).find( 'a.active' ).text() );
    
  // include the tree structure.
  // - use stack to help extracting tree structure
  // - use 2 2-dimension array
  //   - first for conceptStructure (the tree structure)
  //   - second for the concept content
  // - this 2 array, later will be merged
  // extracting structure will use id of elements
  // = variables =
  var treeDepestLevel = 0;
  var treeCurrentLevel = 0;
  var treeStructureStack = [];
  var conceptStructure = [];
  var conceptContent =[];
  
  // console.log($tableElem);

  // tablecontent, get all of tr
  $tableElem.find( 'tr').each( function(){
    var conceptStructureRow = [];
    var conceptContentRow = [];
    
    // get tr detail, regarding its concept and id
    // var trConcept = $( this ).attr( "concept" );
    var trConcept = $( this ).attr( "topic" );
    var trId = $( this ).attr( "id" );

    var elementClassRow = $( this ).attr( "class" );
    var isHideRow = undefined;
    if (elementClassRow !== "undefined"){
      isHideRow = false;
      if (elementClassRow.includes("hide")){
        isHideRow = true;
      }
    }
    TextDecoderStream;

    if ( typeof trConcept === "undefined" ) {
      treeCurrentLevel = 1;
    } else {
      treeCurrentLevel = 0;
    }
    
    // loop through tr children either td or th
    $( this ).children().each( function( index ){
      var columnData = "";
      var elementClassCol = $( this ).attr( "class" );
      var isHideCol = undefined;

      if (isHideRow == true){
        isHideCol = true;
      }
      else{
        if (elementClassCol !== "undefined"){
          isHideCol = false;
          if (elementClassCol.includes("hide")){
            isHideCol = true;
          }
        }
      }

      if( $( this ).find( "span.studyHeader").length === 0 )
        columnData = $.trim( $( this ).text());
      // removing white space that can not be done with trim
      columnData = columnData.replace(/\s+/g, ' ');
      // check if there is a comma in the column text
      if( columnData.indexOf( separator ) !== -1)
        columnData = '"' + columnData + '"';
        
      if (isHideCol !== true){
        if( index == 0 ){ // processing first column (the tree)
          for(var i=0 ; i <= treeCurrentLevel ; i++ ){
            if( i == treeCurrentLevel)
              conceptStructureRow.push( columnData );
            else
              conceptStructureRow.push( "" );
          }
          
        } else { // processing the rest columns
          if ( $(this).attr("class") !== "showIfEmpty" ) {
            conceptContentRow.push( columnData );
            // if contain colspan
            var columnColspan = $( this ).attr( 'colspan' );
            if( typeof columnColspan !== "undefined" && columnColspan !== false )
            for(var i=1 ; i < columnColspan ; i++)
              conceptContentRow.push( conceptContentRow[ conceptContentRow.length - 1 ]);
          }
        }
      }
    });

    if (isHideRow !== true){
      conceptStructure.push( conceptStructureRow );
      conceptContent.push( conceptContentRow );
    }
  });
  
  // merge the two array
  for( var i = 0 ; i < conceptStructure.length ; i++ ){
    // get the length of first array
    var structureLength = conceptStructure[i].length;
    // before merging, equate the length of structure array
    for( var j = structureLength; j <= treeDepestLevel ; j++ ){
      conceptStructure[i].push( "" ); // push empty value
    }
    tableArrayContent.push(  conceptStructure[i].concat( conceptContent[i] ) );
  }
  // print csv
  printTable( $triggerElem, tableTitle, tableArrayContent, separator, "csv" );
  
}

/* dataset table export - Exporting Dataset availability over time & countries */
function exportDatasetCountries( $triggerElem , separator){
  separator = typeof separator !== 'undefined' ? separator : ",";
  var $tableElem = $( 'table.M_TableContent' );
  
  // the variables
  var tableTitle = [];
  var tableArrayContent = [];
  var numberOfDataset = 1;
  
  tableTitle.push("MISSY");
  
  // get the title and change sequence so studyGroup will be added first
  var h1String = $('.ym-g75 > h1').text();
  h1Parts = h1String.split(": ");
  tableTitle.push(h1Parts[1]);
  tableTitle.push(h1Parts[0]);
  //tableTitle.push( $( document ).find( "h1:first" ).text() );
  
  // get the sub title if exist
  if( $( '#M_underline' ).length ){
    var subTitle = $.trim($( '#M_underline' ).text());
    // removing white space that can not be done with trim
    subTitle = subTitle.replace(/\s+/g, '');
    tableTitle.push( subTitle );
    
    // calculate the number of dataset types
    var arrayOfDataset = subTitle.split( "|" );
    numberOfDataset = arrayOfDataset.length;
  }

  // tablecontent, get all of tr
  $tableElem.find( 'tr').each( function( index ){
    
    // first check element visibility, skip if invisible
    if( !$( this ).is( ":visible" ) )
      return true;
      
    var rowData = [];
    // loop through tr children either td or th
    $( this ).children().each( function( index2){
      if( index === 0 && index2 > 0 ){
        // header columns
        var columnData = $.trim( $( this ).text());
        rowData.push( columnData );
        for( var i=1 ; i < numberOfDataset ; i++ )
          rowData.push( columnData );
        
      } else {
        var $content = $( this ).find( '.M_existant,.M_nonExistant' );
        if( $content.length ){
          $content.each( function(){
            var columnData = $.trim( $( this ).text());
            columnData = columnData.replace(/\s+/g, '');
            if( $( this ).hasClass( 'M_existant' ) )
              rowData.push( columnData + "(1)" );
            else
              rowData.push( columnData + "(0)" );
          });
        } else {
          var columnData = $.trim( $( this ).text());
          // removing white space that can not be done with trim
          // columnData = columnData.replace(/\s+/g, ' ');
          // check if there is a comma in the column text
          if( columnData.indexOf( separator ) !== -1)
            columnData += '"' + columnData + '"';
          rowData.push( columnData );
        }
      }
      
    });
    // push the data
    tableArrayContent.push( rowData );
  });
  // removing last row - unnecessary bottom column header
  tableArrayContent.pop();
  // print csv
  printTable( $triggerElem, tableTitle, tableArrayContent, separator, "csv" );
}

/* variable compare CSV export  */
function exportCompareVariables( $triggerElem , separator){
  separator = typeof separator !== 'undefined' ? separator : ",";
  
  // select active table element
  var $containerElem = $( 'div.tabContent' );
  var $tableElem = null;
  if( $containerElem.length > 1)
    $tableElem = $( 'div.tabContent.currentTab' ).find( 'table.M_TableContent' );
  else
    $tableElem = $( 'table.M_TableContent' );
  
  if( typeof $tableElem === "undefined" ){
    alert( "table missing" );
    return false;
  }
  
  // the variables
  var tableTitle = [];
  var tableArrayContent = [];
  // find cell length for a variable
  var cellLengthForAVariable = 1;
  
  tableTitle.push("MISSY");
  
  // get the title
  tableTitle.push( $( document ).find( "h1:first" ).text() );
  
  // get the sub title if exist
  if( $( 'a.active' ).length ){
    var subTitle = $.trim($( 'a.active' ).text());
    // removing white space that can not be done with trim
    subTitle = subTitle.replace(/\s+/g, ' ');
    tableTitle[0] += "-" + subTitle ;
    // calculate the cell needed by frequencies
    if( subTitle.indexOf( "Frequencies" ) > -1 ){
      $freqRowHeader = $tableElem.find( "tr#FrequenciesRowHeader:visible" );
      if( typeof $freqRowHeader !== "undefined" )
        $tdRowHeader = $freqRowHeader.find( "td.compare1" );
      if( typeof $tdRowHeader !== "undefined" )
        cellLengthForAVariable = $tdRowHeader.find( "span" ).length;
    }
  }
  
  // = variables =
  var treeDepestLevel = 0;
  var treeCurrentLevel = 0;
  var treeStructureStack = [];
  var tableLeftHeader = [];
  var tableContent =[];

  // tablecontent, get all of tr
  $tableElem.find( 'tr').each( function( index ){
    
    // first check element visibility, skip if invisible
    if( !$( this ).is( ":visible" ) )
      return true;
      
    var tableLeftHeaderRow = [];
    var tableContentRow = [];
    var isAFrequencyRow = false;
    
    // get tr detail, regarding its concept and id
    var $imgExpand = $( this ).find( "img.expandable" );
    if( index > 0 &&  typeof $imgExpand !== "undefined" )
      var trSection = $imgExpand.attr( "id" );
    var trId = $( this ).attr( "id" );
    
    // decide the level of tree node
    // level 0 (root) has concept and odesn't have id
    if( typeof trSection !== "undefined" && typeof trId === "undefined" ){
      treeCurrentLevel = 0;
      treeStructureStack[0] = trSection;
      //var existIndex = $.inArray(trSection, treeStructureStack);
      //if( existIndex !== -1)
      //  treeStructureStack.push( trSection );
    } else if( typeof trSection === "undefined" && typeof trId !== "undefined" ){
      // has both concept and id - middle level anf leaf
      var currentIdArr = trId.split( "Row" );
      var currentId = currentIdArr[0];
      //tree current level
      var existIndex = $.inArray(currentId , treeStructureStack);
      treeCurrentLevel = existIndex + 1;
      // insert concept
      treeStructureStack[treeCurrentLevel] = trSection;
      // check for deepest level
      if( treeCurrentLevel > treeDepestLevel )
        treeDepestLevel = treeCurrentLevel;
      // check for freq row
      if( currentId.indexOf( "Frequencies" ) > -1)
        isAFrequencyRow = true;
    } else {
      // have neither concept or id (empty structure)
      treeCurrentLevel = 0;
    }
          
    // loop through tr children either td or th
    $( this ).children().each( function( index2 ){
      var columnData = [];
      if( index2 == 0 ){ // processing first column (the tree)
        columnData[0] = $.trim( $( this ).text());
        columnData[0] = columnData[0].replace(/\s+/g, ' ');
        if( columnData[0].indexOf( separator ) !== -1)
          columnData[0] += '"' + columnData[i] + '"';
          
        for(var i=0 ; i <= treeCurrentLevel ; i++ ){
          if( i == treeCurrentLevel)
            tableLeftHeaderRow.push( columnData[0] );
          else
            tableLeftHeaderRow.push( "" );
        }
        
      } else { // processing the rest columns
        // check for frequencies cell
        if( isAFrequencyRow ){
          if( $( this ).find( "a" ).length )
            $( this ).find( "a" ).find( "span" ).each( function( index3 , spanElem ){
              columnData[ index3 ] =  $.trim( $( spanElem ).text());
            });
          else
            $( this ).find( "span" ).each( function( index3 , spanElem ){
              columnData[ index3 ] =  $.trim( $( spanElem ).text());
            });
        }
        else
          columnData[0] = $.trim( $( this ).text());
          
        for( var i=0 ; i < columnData.length ; i++ ){
          // removing white space that can not be done with trim
          columnData[i] = columnData[i].replace(/\s+/g, ' ');
          // check if there is a comma in the column text
          if( columnData[i].indexOf( separator ) !== -1)
            columnData[i] += '"' + columnData[i] + '"';
        }
      
        for( var i=0 ; i < columnData.length ; i++ ){
          tableContentRow.push( columnData[i] );
        }
        // check for correct cell length needed for comparing a variable
        if( columnData.length < cellLengthForAVariable )
          for( var i = columnData.length ; i < cellLengthForAVariable ; i++ )
            tableContentRow.push( "" );
      }
      
    });
    // push the data
    tableLeftHeader.push( tableLeftHeaderRow );
    tableContent.push( tableContentRow );
  });
  // merge the two array
  for( var i = 0 ; i < tableLeftHeader.length ; i++ ){
    // get the length of first array
    var structureLength = tableLeftHeader[i].length;
    // before merging, equate the length of structure array
    for( var j = structureLength; j <= treeDepestLevel ; j++ ){
      tableLeftHeader[i].push( "" ); // push empty value
    }
    tableArrayContent.push(  tableLeftHeader[i].concat( tableContent[i] ) );
  }
  // print csv
  printTable( $triggerElem, tableTitle, tableArrayContent, separator, "csv" );
}


/* Print the 2 dimensional javascript array as table result 
@Param 
$triggerElem - an anchor element for triggering the export function
tableTitle - an array, containing table title and table subtitle
tableArrayContent -  the 2 dimensional javascript array, represented the table
type - e.g csv,txt
     - other format such as pdf can be created with additional library.
separator  - such as "," or ";"
*/
function printTable( $triggerElem, tableTitle, tableArrayContent, separator, type ){
  // defaults
  separator = typeof separator !== 'undefined' ? separator : ",";
  type = typeof type !== 'undefined' ? type : "csv";
  // printed content
  var tableContent = "";
  
  // loop for title
  for( var h = 0; h < tableTitle.length ; h++ ){
    tableContent += tableTitle[h] + "\n";
  }
  
  // loop for table content rows
  for( var i = 0; i < tableArrayContent.length ; i++ ){
    var rowData = "";
    // loop for column
    for( var j = 0; j < tableArrayContent[i].length ; j++ ){
      rowData += tableArrayContent[i][j] + separator;
    }
    // remove last separator
    rowData = rowData.substring(0, rowData.length -1);
    tableContent += rowData + "\n";
  }
  
  // removing last newline
  tableContent = tableContent.substring(0, tableContent.length -1);
  
  // finally encode to base64
  //alert(tableContent.length);
  var base64data = "base64," + $.base64.encode( tableContent );
  //alert(base64data.length);
  
  // downloading static file via javascript only supported by chrome, firefox, opera
  var browserAgent = checkBrowserType();
  // add date for filename
  var currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  // set file name
  var filename = "";
  for (i = 0; i < tableTitle.length; ++i) {
    // console.log("\n"+i+":" + tableTitle[i]);
    filename += tableTitle[i].replace( /[<>:"\/\\|?*]+/g, '' ).replace(/ /g, "-") + "_";
  }
  fileName = filename + currentDate + "." + type;
  //tableTitle[0] = tableTitle[0].replace( /[<>:"\/\\|?*]+/g, '' );
  //fileName = "MISSY_" + tableTitle[0].replace(/ /g, "-") + "_" + currentDate + "." + type;
  
  // can be downloaded if triggered element is an anchor <a> element and the browser also support
  if( $triggerElem.is( "a") && ( browserAgent == "opera" || browserAgent == "firefox" || browserAgent == "chrome") )
    $triggerElem.attr("href", 'data:application/csv;filename='+ fileName +';' + base64data ).attr("download", fileName );
  else{ // not really supported by the browsers, either downloading without correct file name, or can not be downloaded at all
    window.open('data:application/csv;filename='+ fileName +';' + base64data, fileName);
    alert( "if you unable to download the " + type + " file, please switch to Google Chrome or Mozilla Firefox" );
  }
}

/*Check browser agent by duck-typing*/
function checkBrowserType(){
  if( !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0 )
    return "opera";
  else if ( typeof InstallTrigger !== 'undefined' )
    return "firefox";
  else if ( !!window.chrome)
    return "chrome";
  else if (  Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 )
    return "safari";
  else
    return "ie";
}

window.exportMetaMatrix = exportMetaMatrix;
window.printTable = printTable;